export default "__VITE_ASSET__v5aNcgio__"